export default __webpack_public_path__ + "static/media/InterBold.1eca2d32.ttf";